export const GET_TOUR_STEPS = 'GET_TOUR_STEPS';

export const getTourSteps = data => ({
  type: GET_TOUR_STEPS,
  data,
});
